import * as React from 'react';
import styled from 'styled-components';
import * as classNames from 'classnames';
import { media } from './style-utils';

export interface Props {
  name: string;
  defaultValue: string;
  inputMethod: Function;
  label: string;
  type?: string;
}

export interface State {
  textValue: string;
}

const Wrapper = styled.div`
  width: 640px;
  height: 44px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #666666;
  position: relative;
  margin-top: 16px;
  padding: 2px;
  font-size: 14px;
  input {
    appearance:none;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    text-align: center;
    transition: 256ms;
    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px white inset;
    }
    ${media['phone']`
      font-size: 16px;
    `}
  }

  label {
    position: absolute;
    left: 14px;
    top: 15px;
    color: #888;
    pointer-events: none;
  }

  label.focused {
    top: 4px;
    left: 6px;
    font-size: 9px;
  }

  ${media['tablet'] `width: initial;`}
`;

export class TextField extends React.Component<Props, State> {
  private inputElement: HTMLInputElement;
  private refHandler = {
    input: (ref: HTMLInputElement) => this.inputElement = ref
  };
  constructor(props: Props) {
    super(props);
    this.state = {textValue: props.defaultValue};
    this.inputFocus = this.inputFocus.bind(this);
  }
  render() {
    const labelClass = classNames({
      focused: !!this.state.textValue
    });
    const { defaultValue, name, label, type } = this.props;
    return (
      <Wrapper>
        <input name={name}
          ref={this.refHandler.input}
          onInput={this.inputFocus}
          defaultValue={defaultValue}
          type={type || 'text'}
        />
        <label className={labelClass}>{label}</label>
      </Wrapper>
    );
  }
  private inputFocus() {
    this.setState({textValue: this.inputElement.value});
    this.props.inputMethod(this.inputElement.value);
  }
}

export default TextField;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/TextField.tsx